'use client';

import { useEffect, useState, useCallback } from 'react';

interface YandexInImageAdProps {
  blockId: string;
}

const YandexInImageAd = ({ blockId }: YandexInImageAdProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  const initializeAd = useCallback(() => {
    const render = (imageId: string) => {
      window.yaContextCb = window.yaContextCb || [];
      window.yaContextCb.push(() => {
        window.Ya.Context.AdvManager.render({
          renderTo: imageId,
          blockId,
          type: 'inImage'
        });
      });
    };

    const renderInImage = (images: HTMLImageElement[]) => {
      images.forEach((image) => {
        if (!image.id) {
          image.id = `yandex_rtb_${blockId}-${Math.random().toString(16).slice(2)}`;
        }
        if (image.tagName === 'IMG' && !image.complete) {
          image.addEventListener('load', () => render(image.id), { once: true });
        } else {
          render(image.id);
        }
      });
    };

    const imgs = Array.from(
      document.querySelectorAll('img[data-ya-inimage="1"]')
    ) as HTMLImageElement[];
    renderInImage(imgs);
  }, [blockId]);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const onFirstInteraction = () => {
      window.removeEventListener('scroll', onFirstInteraction);
      window.removeEventListener('mousemove', onFirstInteraction);
      window.removeEventListener('click', onFirstInteraction);
      window.removeEventListener('touchstart', onFirstInteraction);

      timer = setTimeout(() => {
        setShouldRender(true);
      }, 3000);
    };

    ['scroll', 'mousemove', 'click', 'touchstart'].forEach((evt) =>
      window.addEventListener(evt, onFirstInteraction, { once: true })
    );

    return () => {
      ['scroll', 'mousemove', 'click', 'touchstart'].forEach((evt) =>
        window.removeEventListener(evt, onFirstInteraction)
      );
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    // TODO: Watch at the behavior of the ad, if it is not rendered, then remove the shouldRender condition
    if (shouldRender) {
      initializeAd();
    }
  }, [shouldRender, initializeAd]);

  return null;
};

export default YandexInImageAd;
